module.exports = __webpack_public_path__ + "static/img/xinyong-icon1.00be0faa.png";